const CONSTANTS = {
  // LazyLoad Config
  IMG: {
    // Lazy loading images is supported out of box,
    // no extra config needed, set `height` for better
    // experience
    height: 200,
    // This component will be loaded when it's top
    // edge is 100px from viewport. It's useful to
    // make user ignorant about lazy load effect.
    offset: 100,
  },
  // for API
  API: {
    Event: "https://ir.fullerton.com.tw/api/events/3",
    SendMail: "https://ir.fullerton.com.tw/api/contactUs",
  },

  // Header Menu
  // 參數：
  //  hash: SPA內部hash滾動
  //  linkto: 外部連結
  HeaderMenu: [
    { index: 1, title: "最新消息", className: "event", hash: "event" },
    { index: 2, title: "關於我們", className: "about", hash: "PR" },
    { index: 3, title: "事業群", className: "group", hash: "group" },
    { index: 4, title: "加入我們", className: "videoSec", hash: "videoSec" },
    {
      index: 5,
      title: "投資人專區",
      className: "partner",
      linkto: "https://ir.fullerton.com.tw/financial/1",
    },
    {
      index: 6,
      title: "企業永續",
      className: "governance",
      linkto: "https://govern.fullerton.com.tw/governance/1",
    },
    {
      index: 7,
      title: "利害關係人",
      className: "stakeholder",
      linkto: "https://ir.fullerton.com.tw/stakeholder/1",
    },
  ],

  // Footer Menu
  // 參數：
  //  scrollTo: SPA內部hash滾動
  //  linkto: 外部連結
  FooterMenu: [
    [
      { title: "關於我們", scrollTo: "PR" },
      { title: "最新消息", scrollTo: "event" },
      { title: "加入我們", scrollTo: "videoSec" },
    ],
    [{ title: "事業群", scrollTo: "group" }],
    [
      {
        title: "投資人專區",
        linkto: "https://ir.fullerton.com.tw/financial/1",
      },
      {
        title: "企業永續",
        linkto: "https://govern.fullerton.com.tw/governance/1",
      },
      {
        title: "利害關係人",
        linkto: "https://ir.fullerton.com.tw/stakeholder/1",
      },
    ],
    [{ title: "合作夥伴", scrollTo: "partner" }],
  ],

  // for KVS
  Banner: [
    {
      id: "a01",
      imgUrl: require("../../images/KVSlide/01.png"),
      imgUrl_m: require("../../images/KVSlide/01-m.png"),
      vdoUrl: "",
    },
    // {
    //   id: "a02",
    //   imgUrl: require("../../images/KVSlide/02.png"),
    //   imgUrl_m: require("../../images/KVSlide/02-m.png"),
    //   vdoUrl: "",
    // },
    {
      id: "a03",
      imgUrl: require("../../images/KVSlide/03.png"),
      imgUrl_m: require("../../images/KVSlide/03-m.png"),
      vdoUrl: "",
    },
    // {
    //   id: "a04",
    //   imgUrl: require("../../images/KVSlide/04.png"),
    //   imgUrl_m: require("../../images/KVSlide/04-m.png"),
    //   vdoUrl: "",
    // },
    {
      id: "a05",
      imgUrl: require("../../images/KVSlide/05.png"),
      imgUrl_m: require("../../images/KVSlide/05-m.png"),
      vdoUrl: "",
    },
  ],

  // for Group
  Group: [
    // {
    //   title: "整合台灣在地特色體驗的訂位平台",
    //   imageClass: "img niceday",
    //   isInternalPage: false,
    //   link: "https://play.niceday.tw",
    //   linkValue: "play.niceday.tw",
    //   content:
    //     "「Niceday玩體驗」是一個整合台灣在地特色體驗的訂位平台，舉凡數小時的活動體驗，或是一日遊的輕鬆小旅行，都可以在平台上發掘新奇有趣的體驗活動。",
    // },
    {
      title: "提供電影訂票及線上電子票劵服務平台",
      imageClass: "img ez",
      isInternalPage: false,
      link: "https://www.ezding.com.tw",
      linkValue: "www.ezding.com.tw",
      content:
        "「ez訂」為全台最大跨影城訂票平台，提供電影訂票及線上電子票劵服務。目前已整合21間以上的合作銀行及夥伴，並承接超過14個的入口網站訂票流量，提供多元方便訂票服務。",
    },
    {
      title: "提供SaaS軟體線上服務電子商務平台",
      imageClass: "img norton",
      isInternalPage: false,
      link: "http://www.soft-store.com",
      linkValue: "www.soft-store.com",
      content:
        "平台首推網路安全產品-賽門鐵克諾頓軟體。產品除了有多元化的規格及優惠價格，透過最先進的SOS機制(軟體線上服務)，讓消費者即買即可安裝，保障重要資料安全，無須等待。",
    },
    {
      title: "中華電信提供的預付卡通訊服務",
      imageClass: "img ideacard",
      isInternalPage: false,
      link: "https://www.idealcard.com.tw",
      linkValue: "www.idealcard.com.tw",
      content:
        "「Ideal Card如意卡」為中華電信所提供的預付卡通訊服務，讓您享受零月租、免綁約，輕鬆上網、通話、享受4G月租、綁約統統免的超值方案，同時還能持續儲値延長使用效期。",
    },
    {
      title: "原創圖庫提供數位影像服務平台",
      imageClass: "img imagemore",
      isInternalPage: false,
      link: "https://www.imagemore.com.tw",
      linkValue: "www.imagemore.com.tw",
      content:
        "「IMAGEMROE」為提供數位影像服務平台，自製原創圖庫是東方優選圖庫品牌，提供正版、高品質、題材豐富的數位內容授權供各種應用。合作夥伴更橫跨全球知名圖庫供應平台。",
    },
    {
      title: "結合軟硬體應用打造便利智慧生活",
      imageClass: "img iot",
      isInternalPage: true,
      link: "https://www.fullerton.com.tw/#!/IOT",
      linkValue: "www.fullerton.com.tw/IOT/",
      content:
        "透過硬體與軟體相互運用，結合物聯網的概念為基礎，規劃未來監控設備、智慧家庭、個人儲存裝置及消費型電子等產品導入物聯網方案，打造出網網相連便利的智慧生活。",
    },
  ],

  // for Team
  TEAM: [
    {
      name: "Vanessa Tsai",
      dept: "娛樂事業處 / 渠道銷售副理",
      gender: "female",
      img: require("../../images/FtcTeam/Vanessa.png"),
    },
    {
      name: "Allen Chen",
      dept: "娛樂事業處 / 市場經營經理",
      gender: "male",
      img: require("../../images/FtcTeam/Allen.png"),
    },
    {
      name: "Jay Ding",
      dept: "資訊軟體處 / 軟體技術工程師",
      gender: "male",
      img: require("../../images/FtcTeam/Jay.png"),
    },
    {
      name: "Kiki Lin",
      dept: "娛樂事業處 / 資深產品營運專員",
      gender: "female",
      img: require("../../images/FtcTeam/Kiki.png"),
    },
    {
      name: "Kelly Wei",
      dept: "設計處 / 資深視覺設計師",
      gender: "female",
      img: require("../../images/FtcTeam/Kelly.png"),
    },
    {
      name: "Danny Chen",
      dept: "創新研發部 / android工程師",
      gender: "male",
      img: require("../../images/FtcTeam/Danny.png"),
    },
  ],

  // for ImagePopup
  ImagePopup: [
    require("../../images/ImagePopup/0001.jpg"),
    require("../../images/ImagePopup/0002.jpg"),
    require("../../images/ImagePopup/0003.jpg"),
    require("../../images/ImagePopup/0004.jpg"),
    require("../../images/ImagePopup/0005.jpg"),
    require("../../images/ImagePopup/0006.jpg"),
    // require("../../images/ImagePopup/0007.jpg"),
    // require("../../images/ImagePopup/0008.jpg"),
    // require("../../images/ImagePopup/0009.jpg"),
  ],

  //  for Partner Event
  Partner: [
    require("../../images/Partner/001.png"),
    require("../../images/Partner/002.png"),
    require("../../images/Partner/003.png"),
    require("../../images/Partner/004.png"),
    require("../../images/Partner/005.png"),
    require("../../images/Partner/006.png"),
    require("../../images/Partner/007.png"),
    require("../../images/Partner/008.png"),
    require("../../images/Partner/009.png"),
    require("../../images/Partner/010.png"),
    require("../../images/Partner/011.png"),
    require("../../images/Partner/012.png"),
    require("../../images/Partner/013.png"),
    require("../../images/Partner/014.png"),
    require("../../images/Partner/015.png"),
    require("../../images/Partner/016.png"),
    require("../../images/Partner/017.png"),
    require("../../images/Partner/018.png"),
    require("../../images/Partner/019.png"),
    require("../../images/Partner/020.png"),
    require("../../images/Partner/021.png"),
    require("../../images/Partner/022.png"),
    require("../../images/Partner/023.png"),
    require("../../images/Partner/024.png"),
    require("../../images/Partner/025.png"),
    require("../../images/Partner/026.png"),
    require("../../images/Partner/027.png"),
    require("../../images/Partner/028.png"),
  ],

  // for Contact Us Email Group
  offices: [
    { office: "Niceday", email: "service@niceday.tw" },
    { office: "ez訂", email: "service@fullerton.com.tw" },
    { office: "Imagemore", email: "ask@imagemore.com" },
    { office: "Ideal Card", email: "service@idealcard.com.tw" },
    { office: "富爾特軟體平台", email: "service.soft@fullerton.com.tw" },
  ],

  // for Contact Us Text
  SendMailResult: {
    Success:
      "寄送成功！<br>感謝您的來信，屆時將會有專人與您聯繫，敬請耐心等候。",
    Fail: "寄送失敗！<br>出現了非預期的錯誤，請稍後再試。",
  },

  //for video
  video: {
    img1: require("../../style/img/voice01.jpg"),
    img2: require("../../style/img/voice02.jpg"),
    img3: require("../../style/img/voice03.jpg"),
  },
};

export default CONSTANTS;



// WEBPACK FOOTER //
// ./src/components/constants/index.js